export enum AppLocale {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
}
